import api from '../api/client';

export const meiosPagamentoService = {
  // Listar meios de pagamento
  async listar(organizadorId) {
    const response = await api.get(`/organizadores/${organizadorId}/meios-pagamento`);
    return response.data;
  },

  // Criar meio de pagamento
  async criar(organizadorId, dados) {
    const response = await api.post(`/organizadores/${organizadorId}/meios-pagamento`, dados);
    return response.data;
  },

  // Atualizar meio de pagamento
  async atualizar(organizadorId, meioId, dados) {
    const response = await api.put(`/organizadores/${organizadorId}/meios-pagamento/${meioId}`, dados);
    return response.data;
  },

  // Excluir meio de pagamento
  async excluir(organizadorId, meioId) {
    const response = await api.delete(`/organizadores/${organizadorId}/meios-pagamento/${meioId}`);
    return response.data;
  }
};
